import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { BrowserRouter as Router, Route, Redirect } from "react-router-dom";

import "polyfill";

// import registerServiceWorker from "./registerServiceWorker";
import store from "store";

import Main from "pages/Main";

const App = () => {
  return (
    <Provider store={store}>
      <Router>
        <div>
          <Route exact path="/showroom/:area/:showroom" component={Main} />
          <Route exact path="/showroom/sp/:area/:showroom" component={Main} />
          <Route
            exact
            path="/"
            render={() => <Redirect to="/showroom/tokyo/lixil_tokyo" />}
          />
        </div>
      </Router>
    </Provider>
  );
};

ReactDOM.render(<App />, document.getElementById("root"));
// registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js